import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TotemDeviceService {
  private readonly storageKey = 'qr_totem_device_token';

  getToken(): string {
    const existingToken = localStorage.getItem(this.storageKey);

    if (existingToken) {
      return existingToken;
    }

    const token = this.createToken();
    localStorage.setItem(this.storageKey, token);

    return token;
  }

  private createToken(): string {
    if (crypto.randomUUID) {
      return crypto.randomUUID();
    }

    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}
